import type { ObjectBase } from './objectBase.interface'

export interface ImageAsset extends ObjectBase {
  kind: AssetKind
  name: string
  key: string
  webpKey: string
  optimal: string
  baseUrl: string
  metadata?: {
    duration?: number
    size?: number
    sampleRate?: number
    channels?: number
    bitrate?: number
  }
}
export enum AssetKind {
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio',
  Model3D = 'Model3D'
}
